<template>
  <Layout
    :backToRoute="false"
    :backFrameRoute="routeNames.RECHARGE"
  >
    <div >
      <v-flex
        style="font-size: 25px; font-weight: 700;"
        class="d-flex flex-grow-0 px-6 pt-3"
      >
        <v-icon color="primary">add_circle</v-icon>
        <span style="color: var(--primary-color-blue);" class="ml-2">
          {{ $t("recharge.title") }}
        </span>
      </v-flex>
      <v-row
        v-if="amount"
        style="background: #0002300D; width: 390px; margin-left: -32px !important;"
        class="d-flex flex-grow-0 mb-4 px-10 justify-space-between py-5 align-center mt-2"
      >
        <span style="font-size: 18px; font-weight: 500;">{{ $t("balance_refund.current_balance") }}</span>
        <span class="font-weight-bold title"
          ><span class="display font-weight-bold"
            >{{ whole(amount*100) }},</span
          >{{ decimal(amount*100) }}
          <v-icon color="#000230" style="font-size: 15px">{{
            currency_symbol
          }}</v-icon></span
        >
      </v-row>
      <v-flex class="d-flex flex-grow-0 align-center pb-8 mx-6" style=" color: var(--primary-color-blue);"
        ><v-icon style="color: var(--primary-color-blue);">credit_card</v-icon>
        {{ $t("recharge.card_payment") }}</v-flex
      >
      <v-flex class="d-flex flex-grow-1">
        <v-progress-circular
          v-if="loadingIFrame"
          indeterminate
          color="primary"
          class="absolute-center"
        ></v-progress-circular>
        <iframe
          v-if="!loadingIFrame"
          :src="iframe"
          width="100%"
          height="100%"
        ></iframe>
      </v-flex>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout";
import { RequestService } from "../services/request.service";
import errorManager from "@/services/error.manager";
import { whole, decimal } from "../utils/MoneyUtils";
import config from "@/config/app-config";

const requestService = new RequestService();

export default {
  props: ["amount", "paymentMethod", "routeNames", "currency_symbol"],
  data() {
    return {
      iframe: null,
      loadingIFrame: true,
      backAction: {
        show: true,
      },
      paymentMethods: config.PAYMENT_METHODS
    };
  },
  components: {
    Layout,
  },
  methods: {
    whole,
    decimal,
    getPaymentFrame() {
      if (this.paymentMethods.PAYLANDS.key === this.paymentMethod)
        this.rechargePaylands();
      else if (this.paymentMethods.MIT.key === this.paymentMethod)
        this.rechargeMit();
      else if (this.paymentMethods.MERCADOPAGO.key === this.paymentMethod)
        this.rechargeMercadopago();
      else if (this.paymentMethods.PVS.key === this.paymentMethod)
        this.rechargePVS();
    },
    rechargePaylands() {
      const context = this;
      requestService
        .rechargePaylands(context, this.amount*100)
        .then((data) => {
          window.location.href = data.url;
          this.loadingIFrame = false;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
          context.loadedIframe = true;
        });
    },
    rechargeMit() {
      const context = this;
      requestService
        .rechargeMit(context, this.amount*100)
        .then((data) => {
          this.iframe = data.url;
          this.loadingIFrame = false;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
          context.loadedIframe = true;
        });
    },
    rechargeMercadopago() {
      const context = this;
      requestService
        .rechargeMercadopago(context, this.amount*100)
        .then((data) => {
          window.location.href = data.url;
          this.loadingIFrame = false;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
          context.loadedIframe = true;
        });
    },
    rechargePVS() {
      const context = this;
      requestService
        .rechargePVS(context, this.amount*1)
        .then((data) => {
          window.location.href = data.redirectUrl;
          this.loadingIFrame = false;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
          context.loadedIframe = true;
        });
    }
  },
  mounted() {
    if (this.paymentMethod) {
      this.getPaymentFrame();
    } else {
      this.$router.push({
        name: this.routeNames.RECHARGE,
        query: { badPaymentConfig: true },
      });
    }
  },
};
</script>
<style lang="css">
iframe {
  border: none;
  min-height: 390px;
}
.full-width-child {
  position: absolute;
  left: 0;
  top: 300px;
  right: 0;
}
</style>
